import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  constructor() {}

  blockCopyPasteEvents(): void {
    document.addEventListener('keydown', this.onKeyDownHandler);
  }

  unblockCopyPasteEvents(): void {
    document.removeEventListener('keydown', this.onKeyDownHandler);
  }

  private onKeyDownHandler(event: KeyboardEvent): void {
    
    if ((event.ctrlKey || event.metaKey) && (event.key === 'c' || event.key === 'v')) {
      event.preventDefault();
    }
  }
}